import { minMediaQueryMD } from 'PlugAndPlay/_global/js/screenSize';
import { Modal } from '../../modal/js/global';

/**
 * Header search component selector
 * @const {string}
 */
export const HEADER_SEARCH_SELECTOR = '[data-component="header-search"]';

export default function _headerSearch() {
    /**
     * Open action selector
     * @const {string}
     */
    const HEADER_SEARCH_TOGGLE_ACTION_SELECTOR =
        '[data-click="header-search-toggle"]';

    /**
     * Header search open/active class
     * @const {string}
     */
    const HEADER_SEARCH_ACTIVE_CLASS = 'header-search-wrapper--active';

    /**
     * Hamburger open control
     * @const {string}
     */
    const HAMBURGER_MENU_TOGGLE = '[data-click="hamburger-menu-toggle"]';

    /**
     * Hamburger open control
     * @const {string}
     */
    const HAMBURGER_SEARCH_INPUT = '.header-search__input';

    /**
     * Create a new HeaderSearch
     * @param {HTMLElement} headerSearch - The wrapping HTML element of the headerSearch
     * @class
     */
    class HeaderSearch {
        constructor(headerSearchWrapper) {
            this.headerSearchWrapper = headerSearchWrapper;

            // Use existing modalHandler functionality to check if header search shown or not
            this.modalHandler = new Modal(headerSearchWrapper);
            this._listenForMediaQueryChange();

            this.hamburgerToggle = document.querySelector(
                HAMBURGER_MENU_TOGGLE
            );
            if (this.hamburgerToggle) {
                this.hamburgerToggle.addEventListener('click', () => {
                    // need to close header search if hamburger is opening
                    this.closeSearch();
                });
            }

            // Attach event handlers to open
            headerSearchWrapper
                .querySelectorAll(HEADER_SEARCH_TOGGLE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.toggleSearch();
                    });
                });
        }

        /**
         * Function to check if the search is currently open
         */
        isOpen() {
            return this.headerSearchWrapper.matches(
                `.${HEADER_SEARCH_ACTIVE_CLASS}`
            );
        }

        /**
         * Function to open or close the search depending on if open or not already
         */
        toggleSearch() {
            if (this.isOpen()) {
                this.closeSearch();
            } else {
                this.openSearch();
            }
        }

        /**
         * Open the search and handles extras like setting up modal ally and focus.
         */
        openSearch() {
            if (!this.isOpen()) {
                // Add CSS class to activate styling
                this.headerSearchWrapper.classList.add(
                    HEADER_SEARCH_ACTIVE_CLASS
                );
                this.headerSearchWrapper
                    .querySelector(HAMBURGER_SEARCH_INPUT)
                    .focus();
            }
        }

        /**
         * Closes the modal and deactivates any modal ally and media watch
         */
        closeSearch() {
            if (this.isOpen()) {
                // Remove CSS class to deactivate styling
                this.headerSearchWrapper.classList.remove(
                    HEADER_SEARCH_ACTIVE_CLASS
                );
            }
        }

        /**
         * Function to listen to changes to the media query and deactivate the modal ally code
         * when it changes from mobile to tablet/desktop. Does not run if search is always a modal.
         */
        _listenForMediaQueryChange() {
            this.modalHandler.watchForMediaQueryChange(
                minMediaQueryMD,
                () => {
                    this.closeSearch();
                },
                () => {
                    // this._activateModal();
                }
            );
        }
    }

    // Find all components (should only be one) and created handler objects
    const headerSearch = document.querySelectorAll(HEADER_SEARCH_SELECTOR);
    headerSearch.forEach((item) => {
        // Create a new item to modify
        const DOMItem = item;

        // Attach the class instance to our DOMItem
        if (!DOMItem.headerSearch) {
            DOMItem.headerSearch = new HeaderSearch(item);
        }
    });
}

_headerSearch();
